// extracted by mini-css-extract-plugin
export default {"container":"WhiteningPage_container__40RLE"};